module.exports = __webpack_public_path__ + "static/media/about.d112f783.png";